import dataStore from './inc/dataStore';
import { herrlichesMenu, mobileSubmenu, hmNavInit } from './inc/header';

document.addEventListener('DOMContentLoaded', () => {
    hmNavInit();
});

/* Author: herrlich media */
window.addEventListener('resize', () => {
    dataStore.docWidth = document.documentElement.clientWidth;
    dataStore.docHeight = document.documentElement.clientHeight;
    dataStore.winHeight = document.documentElement.scrollHeight;

    // window.dispatchEvent(new Event('scroll'));

    clearTimeout(dataStore.endOfResize);
    dataStore.endOfResize = setTimeout(() => {
        mobileSubmenu();
        herrlichesMenu.destroy();
        herrlichesMenu.init();
    }, 250);
});
